import { aliasesList } from "./aliases-list";

const normalize = (str: string) => {
    const dasherized = str
        .replace(/-*([A-Z]+)/g, '-$1')
        .replace(/^-+/, '')
        // .replace(/\-+/, '-')
        .toLowerCase();

    return `--${dasherized}`;
};

export const cssAliases = () => {
    const list = aliasesList.map((str) => [str, normalize(str)]);
    const rules = list.map(([from, to]) => `${from}: var(${to});`).join('\n');

    return `
    * {
      ${rules}
    }  
  `;
};